import { loadView } from '@/router'

export default [
  {
    path: '/legacy',
    name: 'legacy',
    component: loadView('Legacy'),
    redirect: {
      name: 'legacy-handover'
    },
    children: [
      {
        path: 'handover',
        name: 'legacy-handover',
        component: loadView('Legacy/Handover')
      },
      {
        path: 'switch-teams',
        name: 'legacy-switchteams',
        component: loadView('Legacy/SwitchTeams')
      },
      {
        path: 'sign-out',
        name: 'legacy-signout',
        component: loadView('Legacy/SignOut')
      }
    ]
  }
]
